import { config } from '@/config';

export const removeLocaleFromUrl = (url: string) => {
    const localePrefix = config.locales.find((locale) => url?.startsWith(`/${locale}`));

    if (localePrefix) {
        const remainingUrl = url?.substring(
            localePrefix ? localePrefix.length + 1 : localePrefix.length,
        );
        return remainingUrl || '/';
    }

    return url;
};
